let messageApi = null;
const activeToasts = new Set();
const MAX_TOASTS = 3;

const TOAST_CONFIG = {
  duration: 3,
  maxCount: MAX_TOASTS,
  placement: 'topRight',
};

export const setMessageApi = (api) => {
  messageApi = api;
};

const showToast = (type, content, key) => {
  if (!messageApi) {
    console.warn(`Toast [${type}]:`, content);
    return;
  }

  const toastKey = key || `${type}-${content}`;

  if (activeToasts.has(toastKey)) return;

  if (activeToasts.size >= MAX_TOASTS) {
    const firstKey = activeToasts.values().next().value;
    messageApi.destroy(firstKey);
    activeToasts.delete(firstKey);
  }

  activeToasts.add(toastKey);

  messageApi.open({
    type,
    content,
    key: toastKey,
    duration: TOAST_CONFIG.duration,
    onClose: () => activeToasts.delete(toastKey),
  });
};

export const toast = {
  success: (content, key) => showToast('success', content, key),
  error: (content, key) => showToast('error', content, key),
  warning: (content, key) => showToast('warning', content, key),
  info: (content, key) => showToast('info', content, key),
  loading: (content, key) => showToast('loading', content, key),
  destroy: (key) => {
    if (messageApi) messageApi.destroy(key);
    if (key) activeToasts.delete(key);
    else activeToasts.clear();
  },
};

export default toast;
